import * as React from 'react';

import { Typography } from '@mui/material';


export default function BoxSx({label,value}) {
  return (
    <div
      style={{
        border:"1px solid rgba(0, 0, 0, 0.2)",
        borderRadius:"10px",
        margin:"3px",
        padding:"5px"
    
      }}
    >
        <div style={{ display:"flex",flexDirection:"column"}}>
        <span style={{color:"rgba(0, 0, 0, 0.5)",fontWeight:600,fontSize:"12px"}}>{label}</span>
            <Typography style={{margin:"auto",fontSize:"12px",fontWeight:800}} variant='title2'>{value}</Typography>
            
        </div>
        </div>
  );
}